import { useState } from 'react';
import { Link } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { BrandLogo } from '../brand/BrandLogo';
import { usePageTitle } from '../usePageTitle';
import { goToServer, HOME_PATH } from '../server';
import { OnboardingLauncher } from '../../onboarding/OnboardingLauncher';
import { Icon } from '../../ui';
import styles from './WorkspaceWelcome.module.css';
import { LogoutButton } from './LogoutButton';
import { DemoAccountButton } from './DemoAccountButton';

export function WorkspaceWelcome({ displayName }: { displayName: string }) {
  usePageTitle('Connect your Facebook Account');
  const [connecting, setConnecting] = useState(false);
  const queryClient = useQueryClient();
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Link to="/" aria-label="AdOrchestrator home">
          <BrandLogo height={28} />
        </Link>
        <div className={styles.headerActions}>
          <Link to="/account">Your account</Link>
          <LogoutButton member />
        </div>
      </header>
      <main className={styles.main}>
        <section className={styles.card} aria-labelledby="workspace-start-title">
          <span className={styles.mark}>
            <Icon name="layers" size={24} />
          </span>
          <p className={styles.eyebrow}>YOUR WORKSPACE IS READY</p>
          <h1 id="workspace-start-title">Let’s bring your campaigns into focus.</h1>
          <p className={styles.intro}>
            Welcome, {displayName}. Connect Facebook to see your spend, results and campaign
            performance in one clear view.
          </p>
          <button type="button" className={styles.connect} onClick={() => setConnecting(true)}>
            Connect your Facebook Account <Icon name="arrow-right" size={24} />
          </button>
          <p className={styles.reassurance}>
            <Icon name="shield-check" size={16} /> You choose the accounts. Your live ads stay
            view-only.
          </p>
          <div className={styles.benefits}>
            <span>
              <Icon name="wallet" size={20} /> Track your spend
            </span>
            <span>
              <Icon name="layers" size={20} /> Find stronger campaigns
            </span>
            <span>
              <Icon name="bell" size={20} /> Catch changes earlier
            </span>
          </div>
          <DemoAccountButton className={styles.sample} />
        </section>
      </main>
      <OnboardingLauncher
        open={connecting}
        onClose={() => setConnecting(false)}
        onConnected={async () => {
          queryClient.clear();
          goToServer('api', HOME_PATH);
        }}
      />
    </div>
  );
}
